<template>
  <div id="application">
    <router-view />
  </div>
</template>

<script>
import {calculateWindowSize} from './utils/helpers';

export default {
  watch: {
    currentWindowSize: (value) => {
      console.log(value);
    }
  },
  computed: {
    currentWindowSize() {
      if (this.$store.getters['ui/screenSize'] !== this.windowSize) {
        this.$store.dispatch('ui/setWindowSize', this.windowSize);
      }
      return this.windowSize;
    },
    windowSize() {
      return calculateWindowSize(this.windowWidth);
    }
  },
  data() {
    return {
      windowWidth: window.innerWidth,
    }
  },
  mounted() {
    window.onresize = () => {
      this.windowWidth = window.innerWidth
    }
  },
}

</script>

<style>
.main-header .navbar-nav .nav-item .nav-link {
  background: transparent;
  border: none;
  outline: none;
  cursor: pointer;
}

.scroll-wrapper, .table-wrapper {
  width: 100%;
  overflow-y: hidden;
}

.scroll-wrapper {
  height: 20px;
}

.scroll {
  height: 20px;
}

</style>
